export default __webpack_public_path__ + "static/media/Lock.461482e0.svg";